import React from 'react';
import './BusAmenities.css';
import { BusAmenities } from '../../pages/runtime-typechecker';

type BusAmenitiesProps = {
  busAmenities: BusAmenities[];
};
const BusAmenitiesList = ({ busAmenities }: BusAmenitiesProps) => {
  return (
    <div className="amenitiesWrap clearFix">
      {busAmenities.map(({ name, url }, idx) => (
        <div className="amenitiesCard" key={`amenity_` + idx}>
          <span className="amenitiesIconWrap appendBottom5">
            <img
              className="lazyload "
              width="32px"
              height="32px"
              data-src={url}
              alt="bus amenities"
            />
          </span>
          <p className="textCenter font12 lineHeight16 blackText">{name}</p>
        </div>
      ))}
    </div>
  );
};

export default BusAmenitiesList;
